// 템플릿 이름 검증 — 내러티브/문항 템플릿 매니저가 함께 쓴다.
//
// 이름 컬럼이 NVARCHAR(200)이라 그보다 긴 이름을 보내면 드라이버가 던진 원문
// ("Validation failed for parameter 'name'. Data would be truncated." 류)이 500에 실려
// 그대로 alert에 찍혔다. 화면에서 먼저 막고, 그래도 올라온 5xx는 사람이 읽을 문구로
// 바꿔서 보여 준다. 한도는 백엔드 서비스의 NAME_MAX와 같은 값을 유지해야 한다.

export const TEMPLATE_NAME_MAX = 200;

// 문제가 있으면 사용자에게 보여 줄 문구를, 없으면 null을 돌려준다.
export function templateNameError(name) {
  const trimmed = (name || "").trim();
  if (!trimmed) return "템플릿 이름을 입력해 주세요.";
  if (trimmed.length > TEMPLATE_NAME_MAX) {
    return `템플릿 이름은 ${TEMPLATE_NAME_MAX}자까지 입력할 수 있습니다. (현재 ${trimmed.length}자)`;
  }
  return null;
}

// 서버가 4xx로 내려 준 메시지는 우리가 쓴 안내 문구라 그대로 보여 준다. 5xx나 응답
// 자체가 없는 경우(네트워크 오류)는 내부 오류 원문이 새어 나오므로 fallback으로 덮는다.
export function templateErrorMessage(err, fallback) {
  const status = err?.response?.status;
  const message = err?.response?.data?.error?.message;
  if (message && status && status < 500) return message;
  return fallback;
}
